(() => {
  if (customElements.get('vira-stock-status')) return;

class ViraStockStatus extends HTMLElement {
  connectedCallback() {
    this.countElement = this.querySelector('[data-viewer-count]');
    if (!this.countElement || this.onVisibilityChange) return;
    const number = (value, fallback) => Number.isFinite(Number(value)) && value !== '' ? Math.floor(Number(value)) : fallback;
    this.minimum = Math.max(1, Math.min(30, number(this.dataset.viewerMin, 8)));
    this.maximum = Math.max(this.minimum, Math.min(30, number(this.dataset.viewerMax, 20)));
    this.intervalMs = Math.max(10, Math.min(120, number(this.dataset.switchSeconds, 15))) * 1000;
    this.count = Math.max(this.minimum, Math.min(this.maximum, number(this.countElement.textContent, 15)));
    this.countElement.textContent = String(this.count);
    this.onVisibilityChange = () => this.syncTimer();
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    this.syncTimer();
  }

  syncTimer() {
    clearInterval(this.timer);
    this.timer = null;
    if (!this.isConnected || document.visibilityState === 'hidden') return;
    this.timer = setInterval(() => {
      const step = 1 + Math.floor(Math.random() * 2);
      const direction = Math.random() < 0.5 ? -1 : 1;
      this.count = Math.max(this.minimum, Math.min(this.maximum, this.count + direction * step));
      this.countElement.textContent = String(this.count);
    }, this.intervalMs);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    this.timer = null;
    if (this.onVisibilityChange) document.removeEventListener('visibilitychange', this.onVisibilityChange);
    this.onVisibilityChange = null;
  }
}

if (!customElements.get('vira-stock-status')) customElements.define('vira-stock-status', ViraStockStatus);

})();
